export enum BreakpointType {
  ANY = 'any',
  MEDIUM_ISSUE = 'medium_issue',
  HIGH_ISSUE = 'high_issue',
  CRITICAL_ISSUE = 'critical_issue'
}
